import { ISeparatorOption } from '../../interface/Separator'

export const defaultSeparatorOption: Readonly<Required<ISeparatorOption>> = {
  lineWidth: 1,
  strokeStyle: '#000000'
}
